export const getPatientsData = state => state.patients.all;
export const getPatientsSource = state => state.patients.all.source;
export const getPatientData = state => state.patients.patient;
export const patientsIsFetching = state => state.patients.loading.all;
export const patientIsFetching = state => state.patients.loading.patient;
export const patientIsDeleting = state => state.patients.loading.deletePatient;